import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { EXTERNAL_URL } from './ArticleLinkField';

/**
 * What a link item (an article or news item with `external_url`) shows in
 * place of its text. A reader is sent straight on to the address, in the same
 * tab; someone who may edit the item stays, sees where it leads and gets a
 * button to follow it - otherwise the item could never be opened for editing.
 */
function ExternalLinkNotice({ url, canEdit }) {
  const { t } = useTranslation();
  const valid = EXTERNAL_URL.test(url ?? '');

  useEffect(() => {
    if (valid && !canEdit) {
      window.location.replace(url);
    }
  }, [url, canEdit, valid]);

  if (!valid) {
    return null;
  }

  return (
    <div className="maincol">
      <div className="external-link-notice" role="status">
        <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />

        <div>
          <p className="external-link-notice__text">
            {canEdit ? t('articleLink.editorNotice') : t('articleLink.redirecting')}
          </p>

          <a className="external-link-notice__url" href={url} rel="noopener noreferrer">
            {url}
          </a>

          {canEdit && (
            <div className="external-link-notice__actions">
              {/* A plain link styled as the primary button: Button only knows
                  in-app routes (`to`). */}
              <a className="ui-button account-primary-button" href={url} rel="noopener noreferrer">
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                {t('articleLink.open')}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExternalLinkNotice;
